import styled from "styled-components";

export const ScreenHeight = styled.div`
    height: 100vh;
    display: flex;
    align-items: center;
`

export const FlexBox = styled.div`
  display:flex;
`

export const FlexRow = styled(FlexBox)`
  flex-direction:row;
`
export const FlexColumn = styled(FlexBox)`
    flex-direction: column;
`
export const FlexRowBetween = styled(FlexRow)`
  justify-content:space-between;
`
export const Line = styled.div`
    width: 100%;
    height: 2px;
    background: #e7eaf9;
    border: solid 0.5px #e7eaf9;
`
export const FlexRowWrap = styled(FlexRow)`
    flex-wrap:wrap;
`

export const ImageContainer = styled.img`
    width: ${({ width }) => width};
    height: ${({ height }) => height};
    ${({ round }) => round && "border-radius: 50%;"}
`
